// extracted by mini-css-extract-plugin
module.exports = {"root":"Confirmation_root__9iRuF","title":"Confirmation_title__f6rM8","text":"Confirmation_text__3yXd9","action":"Confirmation_action__20YR1","error":"Confirmation_error__1lMTr"};